"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.Slide = exports.MainContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = __importDefault(require("../../theme"));
var MainContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  border-radius: 5px;\n"], ["\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  border-radius: 5px;\n"])));
exports.MainContainer = MainContainer;
var Slide = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  transition: 0.5s;\n  margin: 0;\n  padding: 0;\n"], ["\n  height: 100%;\n  width: 100%;\n  transition: 0.5s;\n  margin: 0;\n  padding: 0;\n"])));
exports.Slide = Slide;
var Button = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  border: none;\n  outline: none;\n  color: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 50%;\n  padding: 8px;\n  background: ", ";\n  opacity: 0.3;\n  display: flex;\n  align-items: center;\n\n  ", ";\n"], ["\n  position: absolute;\n  border: none;\n  outline: none;\n  color: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 50%;\n  padding: 8px;\n  background: ", ";\n  opacity: 0.3;\n  display: flex;\n  align-items: center;\n\n  ", ";\n"])), theme_1.default.colorsPalette.white.default, theme_1.default.colorsPalette.black.default, function (_a) {
    var direction = _a.direction;
    if (direction === "left") {
        return "left: 12px;";
    }
    else if (direction === "right") {
        return "right: 12px;";
    }
    return "";
});
exports.Button = Button;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map